module.exports = __webpack_public_path__ + "static/media/Pledge2PlayBg.a3e558b4.jpg";